"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Environment Context Service API Docs
 * Set from Package Json
 *
 * The version of the OpenAPI document: 2.26.19
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentContextApi = exports.EnvironmentContextApiFactory = exports.EnvironmentContextApiFp = exports.EnvironmentContextApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * EnvironmentContextApi - axios parameter creator
 * @export
 */
var EnvironmentContextApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Add a new project to the database
         * @summary Add project
         * @param {PostProjectBody} postProjectBody Project object that needs to be added to the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProject: function (postProjectBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postProjectBody' is not null or undefined
                            (0, common_1.assertParamExists)('addProject', 'postProjectBody', postProjectBody);
                            localVarPath = "/projects";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postProjectBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes a project by given the unique id. Note - requires Admin privileges.
         * @summary Delete an existing project (Application Admin only)
         * @param {object} projectId ID of the project to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: function (projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'projectId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteProject', 'projectId', projectId);
                            localVarPath = "/projects/{project_id}"
                                .replace("{".concat("project_id", "}"), encodeURIComponent(String(projectId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns multiple projects from ads
         * @summary Find ADS projects
         * @param {string} number Project number to search for, include job number and suffix
         * @param {boolean} [search] Search for projects within ADS, brings back top 25 projects, relating to number entered in the query
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAdsProjects: function (number, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'number' is not null or undefined
                            (0, common_1.assertParamExists)('getAdsProjects', 'number', number);
                            localVarPath = "/ads/projects";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (number !== undefined) {
                                localVarQueryParameter['number'] = number;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns multiple projects from ads
         * @summary Find ADS projects
         * @param {string} number Project number to search for, include job number and suffix
         * @param {boolean} [search] Search for projects within ADS, brings back top 25 projects, relating to number entered in the query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArupDbProjects: function (number, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'number' is not null or undefined
                            (0, common_1.assertParamExists)('getArupDbProjects', 'number', number);
                            localVarPath = "/arupdb/projects";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (number !== undefined) {
                                localVarQueryParameter['number'] = number;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all countries assets contained within Arup
         * @summary Finds all countries within Arup
         * @param {object} [countryId] unique guid of the country
         * @param {object} [regionId] unique guid of the region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: function (countryId, regionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/countries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (countryId !== undefined) {
                                localVarQueryParameter['country_id'] = countryId;
                            }
                            if (regionId !== undefined) {
                                localVarQueryParameter['region_id'] = regionId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all disciplines within Arup
         * @summary Finds all disciplines within Arup
         * @param {Array<string>} [disciplineId] Array of discipline_ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisciplines: function (disciplineId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/disciplines";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (disciplineId) {
                                localVarQueryParameter['discipline_id'] = disciplineId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a single project from the database
         * @summary Find project by ID
         * @param {object} projectId ID of the project to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectById: function (projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'projectId' is not null or undefined
                            (0, common_1.assertParamExists)('getProjectById', 'projectId', projectId);
                            localVarPath = "/projects/{project_id}"
                                .replace("{".concat("project_id", "}"), encodeURIComponent(String(projectId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns multiple projects within the database
         * @summary Find projects
         * @param {Array<string>} [projectId] Array of project ids to search for
         * @param {'created_at' | 'number' | 'name'} [sortBy] Field by which to sort projects by
         * @param {string} [search] search for a source within the database
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {Array<string>} [number] Array of project numbers to search for
         * @param {string} [projectManagerEmail] The email address of the person to filter projects by where they are the PM
         * @param {string} [projectDirectorEmail] The email address of the person to filter projects by where they are the PD
         * @param {string} [recentProjectsFor] return the recent projects of the persons email, relating to projects you\&#39;ve worked on/booked time to.
         * @param {string} [ddbFavoriteProjects] To be a JSON encoded object (string) with the keys in the object being the project_id, number and/or jobName to be in the corresponding object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects: function (projectId, sortBy, search, showActive, showDeleted, order, pageLimit, after, before, number, projectManagerEmail, projectDirectorEmail, recentProjectsFor, ddbFavoriteProjects, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/projects";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (showActive !== undefined) {
                                localVarQueryParameter['show_active'] = showActive;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (number) {
                                localVarQueryParameter['number'] = number;
                            }
                            if (projectManagerEmail !== undefined) {
                                localVarQueryParameter['project_manager_email'] = projectManagerEmail;
                            }
                            if (projectDirectorEmail !== undefined) {
                                localVarQueryParameter['project_director_email'] = projectDirectorEmail;
                            }
                            if (recentProjectsFor !== undefined) {
                                localVarQueryParameter['recent_projects_for'] = recentProjectsFor;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all regions assets contained within Arup
         * @summary Finds all regions within Arup
         * @param {Array<string>} [regionId] Array of region ids to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions: function (regionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/regions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (regionId) {
                                localVarQueryParameter['region_id'] = regionId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all associated data of staff member in arup
         * @summary Finds staff member within Arup by email
         * @param {Array<string>} email Array of staff email addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaff: function (email, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'email' is not null or undefined
                            (0, common_1.assertParamExists)('getStaff', 'email', email);
                            localVarPath = "/staff";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (email) {
                                localVarQueryParameter['email'] = email;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates a single project from the database
         * @summary Update project by ID
         * @param {object} projectId ID of the project to search for
         * @param {PatchProjectBody} patchProjectBody Information that contains updates for the project id specified in the path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProjectById: function (projectId, patchProjectBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'projectId' is not null or undefined
                            (0, common_1.assertParamExists)('patchProjectById', 'projectId', projectId);
                            // verify required parameter 'patchProjectBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchProjectById', 'patchProjectBody', patchProjectBody);
                            localVarPath = "/projects/{project_id}"
                                .replace("{".concat("project_id", "}"), encodeURIComponent(String(projectId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchProjectBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EnvironmentContextApiAxiosParamCreator = EnvironmentContextApiAxiosParamCreator;
/**
 * EnvironmentContextApi - functional programming interface
 * @export
 */
var EnvironmentContextApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EnvironmentContextApiAxiosParamCreator)(configuration);
    return {
        /**
         * Add a new project to the database
         * @summary Add project
         * @param {PostProjectBody} postProjectBody Project object that needs to be added to the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProject: function (postProjectBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addProject(postProjectBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes a project by given the unique id. Note - requires Admin privileges.
         * @summary Delete an existing project (Application Admin only)
         * @param {object} projectId ID of the project to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: function (projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteProject(projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns multiple projects from ads
         * @summary Find ADS projects
         * @param {string} number Project number to search for, include job number and suffix
         * @param {boolean} [search] Search for projects within ADS, brings back top 25 projects, relating to number entered in the query
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAdsProjects: function (number, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAdsProjects(number, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns multiple projects from ads
         * @summary Find ADS projects
         * @param {string} number Project number to search for, include job number and suffix
         * @param {boolean} [search] Search for projects within ADS, brings back top 25 projects, relating to number entered in the query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArupDbProjects: function (number, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getArupDbProjects(number, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all countries assets contained within Arup
         * @summary Finds all countries within Arup
         * @param {object} [countryId] unique guid of the country
         * @param {object} [regionId] unique guid of the region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: function (countryId, regionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCountries(countryId, regionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all disciplines within Arup
         * @summary Finds all disciplines within Arup
         * @param {Array<string>} [disciplineId] Array of discipline_ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisciplines: function (disciplineId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDisciplines(disciplineId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a single project from the database
         * @summary Find project by ID
         * @param {object} projectId ID of the project to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectById: function (projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProjectById(projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns multiple projects within the database
         * @summary Find projects
         * @param {Array<string>} [projectId] Array of project ids to search for
         * @param {'created_at' | 'number' | 'name'} [sortBy] Field by which to sort projects by
         * @param {string} [search] search for a source within the database
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {Array<string>} [number] Array of project numbers to search for
         * @param {string} [projectManagerEmail] The email address of the person to filter projects by where they are the PM
         * @param {string} [projectDirectorEmail] The email address of the person to filter projects by where they are the PD
         * @param {string} [recentProjectsFor] return the recent projects of the persons email, relating to projects you\&#39;ve worked on/booked time to.
         * @param {string} [ddbFavoriteProjects] To be a JSON encoded object (string) with the keys in the object being the project_id, number and/or jobName to be in the corresponding object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects: function (projectId, sortBy, search, showActive, showDeleted, order, pageLimit, after, before, number, projectManagerEmail, projectDirectorEmail, recentProjectsFor, ddbFavoriteProjects, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProjects(projectId, sortBy, search, showActive, showDeleted, order, pageLimit, after, before, number, projectManagerEmail, projectDirectorEmail, recentProjectsFor, ddbFavoriteProjects, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all regions assets contained within Arup
         * @summary Finds all regions within Arup
         * @param {Array<string>} [regionId] Array of region ids to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions: function (regionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRegions(regionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all associated data of staff member in arup
         * @summary Finds staff member within Arup by email
         * @param {Array<string>} email Array of staff email addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaff: function (email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStaff(email, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates a single project from the database
         * @summary Update project by ID
         * @param {object} projectId ID of the project to search for
         * @param {PatchProjectBody} patchProjectBody Information that contains updates for the project id specified in the path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProjectById: function (projectId, patchProjectBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchProjectById(projectId, patchProjectBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.EnvironmentContextApiFp = EnvironmentContextApiFp;
/**
 * EnvironmentContextApi - factory interface
 * @export
 */
var EnvironmentContextApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EnvironmentContextApiFp)(configuration);
    return {
        /**
         * Add a new project to the database
         * @summary Add project
         * @param {PostProjectBody} postProjectBody Project object that needs to be added to the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProject: function (postProjectBody, options) {
            return localVarFp.addProject(postProjectBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes a project by given the unique id. Note - requires Admin privileges.
         * @summary Delete an existing project (Application Admin only)
         * @param {object} projectId ID of the project to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: function (projectId, options) {
            return localVarFp.deleteProject(projectId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns multiple projects from ads
         * @summary Find ADS projects
         * @param {string} number Project number to search for, include job number and suffix
         * @param {boolean} [search] Search for projects within ADS, brings back top 25 projects, relating to number entered in the query
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAdsProjects: function (number, search, options) {
            return localVarFp.getAdsProjects(number, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns multiple projects from ads
         * @summary Find ADS projects
         * @param {string} number Project number to search for, include job number and suffix
         * @param {boolean} [search] Search for projects within ADS, brings back top 25 projects, relating to number entered in the query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArupDbProjects: function (number, search, options) {
            return localVarFp.getArupDbProjects(number, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all countries assets contained within Arup
         * @summary Finds all countries within Arup
         * @param {object} [countryId] unique guid of the country
         * @param {object} [regionId] unique guid of the region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: function (countryId, regionId, options) {
            return localVarFp.getCountries(countryId, regionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all disciplines within Arup
         * @summary Finds all disciplines within Arup
         * @param {Array<string>} [disciplineId] Array of discipline_ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisciplines: function (disciplineId, options) {
            return localVarFp.getDisciplines(disciplineId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a single project from the database
         * @summary Find project by ID
         * @param {object} projectId ID of the project to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectById: function (projectId, options) {
            return localVarFp.getProjectById(projectId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns multiple projects within the database
         * @summary Find projects
         * @param {Array<string>} [projectId] Array of project ids to search for
         * @param {'created_at' | 'number' | 'name'} [sortBy] Field by which to sort projects by
         * @param {string} [search] search for a source within the database
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {Array<string>} [number] Array of project numbers to search for
         * @param {string} [projectManagerEmail] The email address of the person to filter projects by where they are the PM
         * @param {string} [projectDirectorEmail] The email address of the person to filter projects by where they are the PD
         * @param {string} [recentProjectsFor] return the recent projects of the persons email, relating to projects you\&#39;ve worked on/booked time to.
         * @param {string} [ddbFavoriteProjects] To be a JSON encoded object (string) with the keys in the object being the project_id, number and/or jobName to be in the corresponding object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects: function (projectId, sortBy, search, showActive, showDeleted, order, pageLimit, after, before, number, projectManagerEmail, projectDirectorEmail, recentProjectsFor, ddbFavoriteProjects, options) {
            return localVarFp.getProjects(projectId, sortBy, search, showActive, showDeleted, order, pageLimit, after, before, number, projectManagerEmail, projectDirectorEmail, recentProjectsFor, ddbFavoriteProjects, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all regions assets contained within Arup
         * @summary Finds all regions within Arup
         * @param {Array<string>} [regionId] Array of region ids to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions: function (regionId, options) {
            return localVarFp.getRegions(regionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all associated data of staff member in arup
         * @summary Finds staff member within Arup by email
         * @param {Array<string>} email Array of staff email addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaff: function (email, options) {
            return localVarFp.getStaff(email, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates a single project from the database
         * @summary Update project by ID
         * @param {object} projectId ID of the project to search for
         * @param {PatchProjectBody} patchProjectBody Information that contains updates for the project id specified in the path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProjectById: function (projectId, patchProjectBody, options) {
            return localVarFp.patchProjectById(projectId, patchProjectBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EnvironmentContextApiFactory = EnvironmentContextApiFactory;
/**
 * EnvironmentContextApi - object-oriented interface
 * @export
 * @class EnvironmentContextApi
 * @extends {BaseAPI}
 */
var EnvironmentContextApi = /** @class */ (function (_super) {
    __extends(EnvironmentContextApi, _super);
    function EnvironmentContextApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add a new project to the database
     * @summary Add project
     * @param {EnvironmentContextApiAddProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.addProject = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnvironmentContextApiFp)(this.configuration).addProject(requestParameters.postProjectBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes a project by given the unique id. Note - requires Admin privileges.
     * @summary Delete an existing project (Application Admin only)
     * @param {EnvironmentContextApiDeleteProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.deleteProject = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnvironmentContextApiFp)(this.configuration).deleteProject(requestParameters.projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns multiple projects from ads
     * @summary Find ADS projects
     * @param {EnvironmentContextApiGetAdsProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.getAdsProjects = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnvironmentContextApiFp)(this.configuration).getAdsProjects(requestParameters.number, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns multiple projects from ads
     * @summary Find ADS projects
     * @param {EnvironmentContextApiGetArupDbProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.getArupDbProjects = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnvironmentContextApiFp)(this.configuration).getArupDbProjects(requestParameters.number, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all countries assets contained within Arup
     * @summary Finds all countries within Arup
     * @param {EnvironmentContextApiGetCountriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.getCountries = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.EnvironmentContextApiFp)(this.configuration).getCountries(requestParameters.countryId, requestParameters.regionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all disciplines within Arup
     * @summary Finds all disciplines within Arup
     * @param {EnvironmentContextApiGetDisciplinesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.getDisciplines = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.EnvironmentContextApiFp)(this.configuration).getDisciplines(requestParameters.disciplineId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a single project from the database
     * @summary Find project by ID
     * @param {EnvironmentContextApiGetProjectByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.getProjectById = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnvironmentContextApiFp)(this.configuration).getProjectById(requestParameters.projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns multiple projects within the database
     * @summary Find projects
     * @param {EnvironmentContextApiGetProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.getProjects = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.EnvironmentContextApiFp)(this.configuration).getProjects(requestParameters.projectId, requestParameters.sortBy, requestParameters.search, requestParameters.showActive, requestParameters.showDeleted, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.number, requestParameters.projectManagerEmail, requestParameters.projectDirectorEmail, requestParameters.recentProjectsFor, requestParameters.ddbFavoriteProjects, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all regions assets contained within Arup
     * @summary Finds all regions within Arup
     * @param {EnvironmentContextApiGetRegionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.getRegions = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.EnvironmentContextApiFp)(this.configuration).getRegions(requestParameters.regionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all associated data of staff member in arup
     * @summary Finds staff member within Arup by email
     * @param {EnvironmentContextApiGetStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.getStaff = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnvironmentContextApiFp)(this.configuration).getStaff(requestParameters.email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates a single project from the database
     * @summary Update project by ID
     * @param {EnvironmentContextApiPatchProjectByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentContextApi
     */
    EnvironmentContextApi.prototype.patchProjectById = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnvironmentContextApiFp)(this.configuration).patchProjectById(requestParameters.projectId, requestParameters.patchProjectBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EnvironmentContextApi;
}(base_1.BaseAPI));
exports.EnvironmentContextApi = EnvironmentContextApi;
